import { Component, inject, Renderer2, VERSION } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { ScriptService } from './service/scriptService/script.service';
import { AppConst } from './app.constants';
import { UtilityService } from './service/utility/utility.service';
import { VersionService } from './service/api/version/version.service';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { DashboardService } from './service/api/dashboard/dashboard.service';
import { ToastService } from './service/toastService/toast-service';
import { DOCUMENT } from '@angular/common';
// import { MatListModule } from '@angular/material/list';
// import ClientMonitor from '@sixthsense/sixthsense-javascript-agent'; /* Racuten */
// import { environmentProd } from 'src/environments/environment.prod';
// import { RakutenService } from './service/rakuten.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  title = 'metal-admin';
  angularVersion = VERSION.full;
  version = true;
    private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);


  constructor(
    private router: Router,
    private modalService: NgbModal,
    private scriptService: ScriptService,
    private utilty: UtilityService,
    private apiVersion: VersionService,
    private _bottomSheet: MatBottomSheet,
    private tooltipConfig: NgbTooltipConfig,
    private dashboardService: DashboardService,
    private toastService: ToastService
  ) {
    // Render tooltips against <body> so they aren't clipped/z-index-hidden
    // by scrollable table ancestors or the table header.
    this.tooltipConfig.container = 'body';
  }

  ngOnInit() {
    /* Route event check */
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.modalService.dismissAll();

        this.checkChangedVersion();
        this.checkVersion();
        this.updateStoreClass();
      }
    });
    /* Route event check */

    /*
     * Load external CSS/JS
     */
    this.scriptService.loadExternalCss(AppConst.EXTERNAL_CSS.googleAPIFont);
    this.scriptService.loadExternalCss(AppConst.EXTERNAL_CSS.materialIcon);

    this.scriptService.loadJsScript(AppConst.EXTERNAL_JS.bpnmJS);
    this.scriptService.loadJsScript(AppConst.EXTERNAL_JS.sockJs);
    this.scriptService.loadJsScript(AppConst.EXTERNAL_JS.adobeJs);
    /*
     *  Load external CSS/JS
     */

    this.version = true;
    this.updateStoreClass();

    this.useFixedDropdownPositioning();

    this.getFeatureListFromFF4J();

  }
  
  // Get BaseUrls from FF4J
  getFeatureListFromFF4J() {
    const storeId = this.utilty.getStoreLogin();
    const jsonData = {
      featureName: storeId + '.ADMIN_URL',
      filter: ["url"],
    };
    this.dashboardService.getDashletList_API(JSON.stringify(jsonData)).subscribe({
      next: (value) => {
        if (value.hasOwnProperty('status')) {
          // console.log(value);
          // this.toastService.showWarningToast('warning', value.detail)
        } else {
          if (value.hasOwnProperty('properties')) {
            const _urls = JSON.parse(value.properties.url);
            if(storeId == 100 || storeId == 122) {
              this.utilty.setRakutenData(_urls);
              this.utilty.setAgroData(_urls);
              this.utilty.setCommonStoreData(_urls);
              console.log('metalUrlObj', _urls);

            }
            if(storeId == 113 || storeId == 103) {
              this.utilty.setAgroData(_urls);
              this.utilty.setCommonStoreData(_urls);
              console.log('agroUrlObj', _urls);
            }
              
          }
        }
      }, 
      complete: () => { 
        // console.log('inside break');
        // this.utilty.setRakutenData({
        //   RAKUTEN_AUTH: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZWFtSWQiOiJhYzA1OWVmYS1lOGE3LTQxNDAtOGM5MS03MmQ1NmJiODIwZGUiLCJiaWxsaW5nX2lkIjoiMmYwOWQyNWEtMjAyZS00ODg2LWFjOGYtN2JiZjFmMzI3NDJkIiwiaWF0IjoxNzIxMjc4MDA0LCJhdWQiOiJvYXAiLCJpc3MiOiJzaXh0aC1zZW5zLWF1dGgifQ.dKfdpdpbIxKljvMQflT2OR8MfKctn2HDBvpD89iPWJA",
        //   RAKUTEN_COLLECTOR: "https://http-collector-observability.sixthsense.rakuten.com/oap",
        //   RAKUTEN_SERVICE_NAME: "RACE METAL ADMIN DEV",
        //   RAKUTEN_SERVICE_VERSION: "1.0.0",
        //   pythonApi: "https://mtreport-sitanalytics.metaljunction.com/sit/metal/reportAnalysis/"
        // })
      },
    })
    // this.loadCssFromFF4J();
    this.loadCSS('https://auctionv2-docs.metaljunction.com/mailImgaeCSS/store-css/dev/metal.css');
  }


  private loadCSS(url: string) {
    // 1. Create the link element
    const linkElement = this.renderer.createElement('link');

    // 2. Set the attributes for the stylesheet
    this.renderer.setProperty(linkElement, 'rel', 'stylesheet');
    this.renderer.setProperty(linkElement, 'type', 'text/css');
    this.renderer.setProperty(linkElement, 'href', url);

    // 3. Append the link element to the document head
    this.renderer.appendChild(this.document.head, linkElement);
  }


  private useFixedDropdownPositioning() {
    const bootstrapLib = (window as any).bootstrap;
    if (bootstrapLib?.Dropdown) {
      bootstrapLib.Dropdown.Default.popperConfig = { strategy: 'fixed' };
    }
  }

  updateStoreClass() {
    try {
      const storeId = this.utilty.getWorkAreaAndStoreId().storeId;
      if (storeId == 103) {
        document.body.classList.add('store-103');
      } else {
        document.body.classList.remove('store-103');
      }
    } catch (e) {
      // In case userData is not in localStorage yet
    }
  }

  async checkChangedVersion() {
    const checkVersion = await this.utilty.getAppVersion();

    const json = {
      userRoleId: 102,
    };
    this.apiVersion.getAppVersion(JSON.stringify(json)).subscribe({
      next: (value: any) => {
        if (!value.hasOwnProperty('status')) {
          const fromAPIcheck = value.version;
          if (checkVersion.version !== fromAPIcheck) {
            this.openBottomSheet();
          }
        }
      },
      complete: () => { },
      error: (err) => { },
    });
  }

  async checkVersion() {
    const checkVersion = await this.utilty.getAppVersion();
    const jsonData = {
      featureName: "ui.version",
      filter: ["admin"],
    };

    this.apiVersion.getUiVersion(JSON.stringify(jsonData)).subscribe({
      next: (value: any) => {
        if (value.hasOwnProperty("status")) {
        } else {
          if (value.hasOwnProperty("properties")) {
            const response = value.properties["admin"];
            this.version = response == checkVersion.version ? true : false;
          }
        }
      },
      complete: () => { },
      error: (err) => {
        console.log("err : ", err);
      },
    });
  }

  async loadCssFromFF4J() {
    // const checkVersion = await this.utilty.getAppVersion();
    const jsonData = {
      featureName: "ui.style",
      filter: [100],
    };
    this.apiVersion.getUiVersion(JSON.stringify(jsonData)).subscribe({
      next: (value: any) => {
        if (value.hasOwnProperty("status")) {
        } else {
          if (value.hasOwnProperty("properties")) {
            const response = value.properties[100];
            if(response){
              this.loadCSS(response);
            }
          }
        }
      },
      complete: () => { },
      error: (err) => {
        console.log("err : ", err);
      },
    });
  }

  openBottomSheet(): void {
    // this._bottomSheet.open(BottomSheetOverviewExampleSheet);
  }

  reload() {
    if (!(window as any).__karma__) location.reload();
  }
}


// @Component({
//   selector: 'app-version-mismatch',
//   templateUrl: './app-version-mismatch.html',
//   standalone: true,
//   imports: [MatListModule],
// })
// export class BottomSheetOverviewExampleSheet {
//   constructor(
//     private _bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewExampleSheet>,
//   ) {}

//   openLink(event: MouseEvent): void {
//     this._bottomSheetRef.dismiss();
//     event.preventDefault();
//   }
// }